import React from 'react';

import { Dayjs } from 'dayjs';
import PayCycleSeparator from './pay-cycle-separator.component';
import { PendingTimesheet, TimesheetList } from 'features/pending-timesheets/models/pending-timesheets.model';
import TimesheetRow from './timesheet-row.component';

export interface ITimesheetRowsProps {
    payPeriodStart: Dayjs;
    payPeriodEnd: Dayjs;
    timesheets: PendingTimesheet[];
}

const TimesheetRows = (props: ITimesheetRowsProps): JSX.Element => {
    const { payPeriodEnd, payPeriodStart } = props;

    const timesheets = new TimesheetList(props.timesheets).sortByDate();
    const timesheetMap = timesheets.asMap();

    class Separator {
        constructor(public payCycleStart: string, public payCycleEnd: string) {}
    }

    const sortedTimesheets: (PendingTimesheet | Separator)[] = [];

    // combine all the sorted buckets into a single array,
    // separated by payCycleDate "separator" objects
    Object.keys(timesheetMap)
        .sort()
        .reverse()
        .forEach((key: string) => {
            if (key < timesheets.latestStartDate) {
                sortedTimesheets.push(
                    new Separator(timesheetMap[key][0].payPeriodStart, timesheetMap[key][0].payPeriodEnd),
                );
            }

            sortedTimesheets.push(...new TimesheetList(timesheetMap[key]).sort());
        });

    return (
        <>
            {sortedTimesheets.map((entry: PendingTimesheet | Separator) => {
                if (entry instanceof Separator) {
                    return (
                        <PayCycleSeparator
                            key={entry.payCycleStart + '_' + entry.payCycleEnd + '_separator'}
                            payPeriodStart={entry.payCycleStart}
                            payPeriodEnd={entry.payCycleEnd}
                        />
                    );
                } else {
                    return (
                        <TimesheetRow
                            payPeriodStart={payPeriodStart}
                            payPeriodEnd={payPeriodEnd}
                            key={
                                entry.travelerFirstName +
                                entry.travelerLastName +
                                (entry.timesheetId || new Date().valueOf())
                            }
                            timesheet={entry}
                        />
                    );
                }
            })}
        </>
    );
};

export default TimesheetRows;
